var taricFootnote = angular.module('taric.footnote', ['taric.footnote.lookup', 'taric.footnote.view']);
taricFootnote.config(function ($stateProvider) {
    $stateProvider.state('taric.footnote', {
        abstract: true,
        url: '/footnote',
        template: '<ui-view></ui-view>'
    }).state('taric.footnote.lookup', {
        url: '/lookup?frm&sd&fo',
        templateUrl: 'taric/footnote/lookup/footnote-lookup.tmpl.html',
        controller : 'FootnoteLookupController as footnoteLookupCtrl',
        resolve: {
            initializeSearchCriteria: function(FootnoteLookupModel, $stateParams, CommonHelper){
                FootnoteLookupModel.resetSearchCriteria();
                FootnoteLookupModel.resetSearchResult();

                if ($stateParams.sd){
                    var inputDate = CommonHelper.parseInputDate($stateParams.sd);
                    if (inputDate) {
                        FootnoteLookupModel.getSearchCriteria().simulationDate = inputDate;
                    }
                }
                if ($stateParams.fo && $stateParams.fo.length === 5){
                    FootnoteLookupModel.getSearchCriteria().footnoteType = $stateParams.fo.substr(0,2);
                    FootnoteLookupModel.getSearchCriteria().footnoteId = $stateParams.fo.substr(2,4);
                } else if ($stateParams.fo && $stateParams.fo.length === 8) {
                    FootnoteLookupModel.getSearchCriteria().footnoteType = $stateParams.fo.substr(0,3);
                    FootnoteLookupModel.getSearchCriteria().footnoteId = $stateParams.fo.substr(3,7);
                }
            },
            footnoteTypes: function(FootnoteTypeModel){
                return FootnoteTypeModel.queryFootnoteTypes();
            },
            loadTranslation: function ($translatePartialLoader) {
                $translatePartialLoader.addPart('taric/footnote');
            },
            setupMenu: function (MenuModel) {

                MenuModel.setHelpIndex(this.name);
                MenuModel.notifyObservers();
            }
        }
    }).state('taric.footnote.view', {
        url: '/view?sd&fn',
        templateUrl: 'taric/footnote/view/footnote-view.tmpl.html',
        controller : 'ViewFootnoteController as viewFootnoteCtrl',
        resolve: {
            footnote : function (FootnotePopupModel, $stateParams, CommonHelper){
                if ($stateParams.sd && $stateParams.fn){
                    var inputDate = CommonHelper.parseInputDate($stateParams.sd);
                    if (inputDate) {
                        return FootnotePopupModel.findFootnote($stateParams.fn, inputDate);
                    }
                }

                return null;
            },
            loadTranslation: function ($translatePartialLoader) {
                $translatePartialLoader.addPart('taric/nomenclature/sbt');
            },

            setupMenu: function (MenuModel) {

                MenuModel.setHelpIndex(this.name);
                MenuModel.notifyObservers();
            }
        }
    });
});


// WEBPACK FOOTER //
// ./app/taric/footnote/taric-footnote.js